// extracted by mini-css-extract-plugin
export default {"whatsNewPage":"style_whatsNewPage__r69By","card":"style_card__VRwFQ","header":"style_header__738MW","titleBlock":"style_titleBlock__pmiST","totalItems":"style_totalItems__yFaDu"};